export const environment = {
  production: true,
  tenantDomain: 'smartcapacity.dev',
  version: '1.0.0.6D432DD',
  sha: '6D432DD',
};
